import React from 'react';
import type { ActivityEntry, PlatformChange } from 'shared/src/api/activity-feed-api-types';
import { ActivityCardShell } from './ActivityCardShell';

type PlatformSummaryCardProps = {
  entry: ActivityEntry;
  showCampaignName: boolean;
};

export function PlatformSummaryCard({ entry, showCampaignName }: PlatformSummaryCardProps) {
  const platformChanges = (entry.changes ?? []).filter(
    (c): c is PlatformChange => c.kind === 'platform'
  );

  return (
    <ActivityCardShell entry={entry} showCampaignName={showCampaignName}>
      {entry.platformName ? (
        <div className="text-muted-foreground text-sm">{entry.platformName}</div>
      ) : null}

      {platformChanges.length > 0 ? (
        <div className="space-y-1">
          {platformChanges.map((change, idx) => (
            <PlatformChangeRow key={idx} change={change} />
          ))}
        </div>
      ) : (
        <div className="text-muted-foreground text-sm">Configuration changed</div>
      )}
    </ActivityCardShell>
  );
}

/* ---------------------------------------------------------------------------
 * Private helpers
 * --------------------------------------------------------------------------- */

function PlatformChangeRow({ change }: { change: PlatformChange }) {
  const label = toTitleCase(change.field.replace(/_/g, ' '));
  return (
    <div className="text-muted-foreground text-sm">
      <span className="font-medium text-gray-700">{label}</span>
      {' \u00B7 '}
      {change.changeCount} {change.changeCount === 1 ? 'change' : 'changes'}
    </div>
  );
}

function toTitleCase(str: string): string {
  return str.replace(/\b\w/g, c => c.toUpperCase());
}
